import Topbar from "./components/Topbar";
import BreakingTicker from "./components/BreakingTicker";
import Hero from "./components/Hero";
import CollapseArchive from "./components/CollapseArchive";
import Timeline from "./components/Timeline";
import Reputation from "./components/Reputation";
import Feed from "./components/Feed";
import Trust from "./components/Trust";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="flex min-h-screen flex-col bg-background-50">
      <Topbar />
      <BreakingTicker />
      <main className="flex-1">
        <Hero />
        <CollapseArchive />
        <Timeline />
        <Reputation />
        <Feed />
        <Trust />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}